import React from 'react';
import SearchComponent from '@sections/find-an-event/searchComponent';
import { CoupleContainer } from './searchResponse.styles';

const FindACoupleContainer = () => {
  return (
    <CoupleContainer>
      <SearchComponent />
    </CoupleContainer>
  );
};

export default FindACoupleContainer;
